
<script>
  import { Row, Column, Block, Icon, Text, Link } from 'bastone'
  import { colors } from '../consts'
  import { screenWidth, bodyWidth } from '../context'
  import Page from '../components/page.svelte'
  import Header from '../components/header.svelte'
  import MyButton from '../components/button.svelte'
  import BotCard from '../components/botcard.svelte'
  import { notify, currentUser } from '../context'
  import { ChatBot } from '../models'
  import { onMount } from 'svelte'

  let my_bots = []
  let hot_bots = []
  let category_bots = []
  let bindBodyWidth = undefined

  function createBot() {
    if(!$currentUser.is_admin && my_bots.length >= 3) {
      notify('目前每个用户最多创建3个BOT');
      return
    } else {
      location.href='/createbot'
    }
  }

  onMount(()=>{
    ChatBot.getMine().then((res) => {
      my_bots = res
    })
    ChatBot.getHot().then((res) => {
      hot_bots = res
    })
  })

</script>


<Page title='首页'>
  <Header buttonType='chat'/>
  <Column width={$bodyWidth}>
    <Block height=2rem/>

    <Row>
      <Text size=24 bold=1 lineHeight=1.8rem>我的BOT</Text>
    </Row>
    
    <Block height=1rem width=100% bindSize=1 bind:clientWidth={bindBodyWidth}/>
    <Row wrap={true}>
      {#each my_bots as bot}
      <BotCard bot={bot} bind:parentWidth={bindBodyWidth}/>
      {/each}
      <BotCard empty=1 
        bind:parentWidth={bindBodyWidth}
        clickFunc={createBot}
      />
    </Row>
    <Block height=1rem/>


    <Row>
      <Text size=24 bold=1>热门BOT</Text>
    </Row>
    
    <Block height=1rem/>
    <Row wrap={true}}>
      {#each hot_bots as bot}
      <BotCard bot={bot} bind:parentWidth={bindBodyWidth}/>
      {/each}
    </Row>

    <Block height=1.5rem/>
  </Column>

</Page>


